import {put, takeLatest, call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    UPDATE_VENUE,
    UPDATE_VENUE_SUCCESS,
    UPDATE_VENUE_ERROR,
}
    from "../../actions/venue";

function* updateVenueSaga(action) {
    try {
       const data  = yield call(venueService.UpdateVenue,action.payload)
        
       yield put({
        type: UPDATE_VENUE_SUCCESS,
        payload: data
    });


    } catch (error) {
        yield put({
            type: UPDATE_VENUE_ERROR,error: error.data
        });
    }
}


export function* updateVenueSagaWatcher() {
    yield takeLatest(UPDATE_VENUE, updateVenueSaga);
}